<template>
    <div class="payroll-salary-calculation-container">
        <div class="payroll-salary-calculation-panel">
            <div class="payroll-salary-calculation-panel-header">
                <span class="icon">💰</span>
                <h2>Salary Calculation</h2>
            </div>
            <div class="payroll-salary-calculation-panel-body">
                <div class="payroll-salary-calculation-form-group">
                    <label>Total Days Salary (PKR) <span style="font-size: smaller; float: right;">{{
                            formattedPerDayWorkedSalary }} * ({{
                            selectedEmployee.daysWorked || 0 }} Days)</span></label>
                    <input type="text" :value="totalDaysSalaryInputComputed" disabled min="0"
                        class="payroll-disabled-field" />

                </div>
                <div class="payroll-salary-calculation-form-group">
                    <label style="position: relative;">Late Deduction (PKR) <span
                            class="salary-calculation-minus">-</span>
                        <span style="font-size: smaller; float: right;">
                            ({{ formattedPerHoursalary }} / hr * {{ calculatedSalaryDeductionDays * 4 }}x)
                        </span>
                    </label>
                    <input type="number" v-model="lateSalaryDeductionUpdate" :disabled="isDisabled" placeholder="0"
                        min="0" disabled class="payroll-disabled-field" />
                </div>
                <div class="payroll-salary-calculation-form-group">
                    <div style="display: flex; justify-content: space-between; flex-wrap: wrap;">
                        <div class="input-with-reset">
                            <label style="position: relative; margin-right: 5px;">Leaves Encashment (PKR) <span
                                    class="salary-calculation-plus">+</span>
                            </label>
                            <span class="payroll-leave-info-icon" @mouseover="showLeavesInfo"
                                @mouseleave="hideLeavesInfo">
                                <i class="fa fa-info-circle" style="color: yellowgreen;"></i>
                                <div v-if="isleaveInfoVisible" class="payroll-leave-info-tooltip">
                                    <div v-if="!getLeavesAllowed">
                                        Disabled due to 0 Leave Balance.<br>
                                    </div>

                                    <template v-if="leavesEncashmentDetails">
                                        <b>Monthly Leaves Details:</b>
                                        <ul>
                                            <li v-for="(item, index) in leavesEncashmentDetails.details"
                                                :key="'leave-' + index">{{ item }}</li>
                                        </ul>
                                        <b>Late Arrival Penalty Policy:</b>
                                        <ul>
                                            <li v-for="(rule, idx) in formattedLeavePolicy" :key="'policy-' + idx">{{
                                                rule
                                                }}</li>
                                        </ul>
                                    </template>

                                    <template v-else>
                                        <p>No leaves taken for this month.</p>
                                    </template>
                                </div>
                            </span>
                        </div>

                        <div style="font-size: smaller; float: right;">{{
                            formattedLeavesTakenSalary }} * ({{
                            this.leavesDaysReducedByLate + calculateAnnualLeavesEncashmentDays || 0 }} Days)
                        </div>

                    </div>
                    <input type="number" v-model.number="leavesEncashmentAmountUpdate" @input="handleLeaveEncashment"
                        min="0" :disabled="isDisabled" placeholder="0" disabled class="payroll-disabled-field" />
                </div>
                <div class="payroll-salary-calculation-form-group">
                    <div class="input-with-reset">
                        <label>Adjustments (PKR) </label>
                        <ResetIconButton @reset="() => resetIfEmpty('extraAmountAdjustmentInput')" />
                       
                    </div>
                    <div class="adjustment-summary-container">
                        <span style="font-size: smaller;">
                            Low/Extra Hours Sum:
                            → <span :style="{ color: totalSummary.difference.color || 'green' }">{{ totalSummary.difference.text }}</span>
                        </span>
                        <span class="required-hours-tooltip-wrapper" @mouseover="showAdjustmentInfo"
                            @mouseleave="hideAdjustmentInfo">
                            <i class="fa fa-info-circle" style="color: yellowgreen; margin-top:-2px"></i>

                            <div v-if="isAdjustmentInfoVisible" class="required-hours-tooltip-box"
                                style="margin-left: -150px;">
                                <div> <b>Note: </b>Total required hours do not include absents, approved leaves, or half
                                    days.</div>
                                <br>


                                <!-- 🔹 Consolidated Summary (Updated Format) -->
                                <b class="required-hours-tooltip-summary-heading">Summary:</b>
                                <div style="padding-top: 10px; border-top: 1px dashed #aaa; font-size: 11px;">

                                    <div><b class="required-hours-tooltip-summary-bold">Extra Hours:</b>
                                        {{ totalSummary.cumulativeOvertimeHours }}
                                    </div>
                                    <div><b class="required-hours-tooltip-summary-bold">Unpaid Low Hours:</b>
                                        {{ totalSummary.lowAndRemainingLow }}
                                    </div>
                                    <div><b class="required-hours-tooltip-summary-bold">Paid Low Hours:</b>
                                      <span style="color: red;">-{{ totalSummary.remainingNormalHours }}</span>
                                    </div>
                                    <div class="div-top-divider" :style="{ backgroundColor: '#cccccc7d' }"><b class="required-hours-tooltip-summary-bold-total">Total:</b>
                                        <span :style="{ color: totalSummary.difference.color }">
                                            {{ totalSummary.grandTotal }}
                                        </span>
                                    </div>
                                </div>


                                <!-- Group 1 Sections -->
                                <br>
                                <b class="required-hours-tooltip-summary-heading" style="margin-top: 10px;">Hours
                                    Details</b>

                                <template v-for="({ title, items, key }, index) in tooltipSections.slice(0, 4)">
                                    <div v-if="items && items.length">
                                        <div class="required-hours-tooltip-header">
                                            {{ title }} ({{ items.length }})
                                            <span v-if="totalsMap[key]"
                                                :style="{ color: key === 'remainingNormalHours' ? 'red' : totalsMap[key].color, marginLeft: '10px' }">
                                                — Total: {{ totalsMap[key].text }}
                                            </span>
                                        </div>
                                        <div class="required-hours-tooltip-list">
                                            <ul>
                                                <li v-for="(item, index2) in items" :key="`${key}-${index2}`">{{ item }}
                                                </li>
                                            </ul>
                                        </div>
                                        <br />
                                    </div>
                                </template>


                                <!-- Group 2 Sections -->
                                <template v-for="({ title, items, key }, index) in tooltipSections.slice(4)">
                                    <div v-if="items && items.length">
                                        <div class="required-hours-tooltip-header">
                                            {{ title }} ({{ items.length }})
                                            <span v-if="totalsMap[key]"
                                            :style="{ color: key === 'remainingNormalHours' ? 'red' : totalsMap[key].color, marginLeft: '10px' }">
                                            — Total: {{ totalsMap[key].text }}
                                            </span>
                                        </div>
                                        <div class="required-hours-tooltip-list">
                                            <ul>
                                                <li v-for="(item, index2) in items" :key="`${key}-${index2}`">{{ item }}
                                                </li>
                                            </ul>
                                        </div>
                                        <br />
                                    </div>
                                </template>

                            </div>
                        </span>
                        <span class="required-hours-tooltip-wrapper adjustment-days-tag"
                            @mouseenter="adjustmentShowHoverTooltip = true"
                            @mouseleave="adjustmentShowHoverTooltip = false"
                            :style="{ color: totalSummary.difference.color || 'green' }">
                            {{ totalSummary.difference.days }}
                            <div v-if="adjustmentShowHoverTooltip" class="required-hours-tooltip-box adjustment-tooltip-box">
                                <div class="tooltip-label">
                                    Click below to
                                    <strong>{{ appliedAdjustments['lowExtraHours'] ? 'Remove' : 'Add' }}</strong>
                                    Rs. <strong>{{ calcExtraAmountAdjustment }}</strong>
                                </div>
                                <button class="tooltip-action-btn" 
                                        :class="{ 'btn-add': !appliedAdjustments['lowExtraHours'], 'btn-remove': appliedAdjustments['lowExtraHours'] }"
                                        :disabled="calcExtraAmountAdjustment === 0"
                                        @click="applyAdjustment(calcExtraAmountAdjustment, `Rs. ${Math.abs(calcExtraAmountAdjustment)} for Low/Extra Hours Sum: ${totalSummary.difference.text}`)">
                                    {{ appliedAdjustments['lowExtraHours'] ? 'Remove' : 'Add' }}
                                </button>
                            </div>
                        </span>
                    </div>
                    <div class="adjustment-summary-container" v-if="adjustments && adjustments.length">
                        <span style="font-size: smaller;">
                            Other Adjustments: <span>{{ totalAdjustments }}</span>
                        </span>
                        <span class="required-hours-tooltip-wrapper"
                            @mouseover="showAdjustmentDetails" @mouseleave="hideAdjustmentDetails">
                            <i class="fa fa-info-circle" style="color: yellowgreen; margin-bottom: 7px"></i>
                            <div v-if="isAdjustmentDetailsVisible" class="required-hours-tooltip-box payroll-adjustment-info-tooltip">
                                <ul style="list-style: none; padding: 0; margin: 0;">
                                    <li v-for="adj in adjustments" :key="adj.id" class="adjustment-card">
                                        <div :title="adj.reason" class="adjustment-card-content" @click.stop="toggleAdjustment(adj)">
                                        <div class="adjustment-card-details">
                                            <span>Rs. {{ Math.round(Math.abs(typeof adj.amount === 'number' ? adj.amount : calculateAdjustmentAmount(adj.amount))) }} {{ (adj.amount.includes('x') || adj.amount.includes('day')) ? `(${adj.amount})` : '' }} (<span>{{ adj.adjustmentType }}</span>)</span>
                                            
                                            <span class="adjustment-card-reason">{{ adj.reason.length > 30 ? adj.reason.substring(0, 30) + '...' : adj.reason }}</span>
                                            <a v-if="adj.receiptUrl" :href="adj.receiptUrl" target="_blank" rel="noopener"
                                                class="adjustment-card-receipt" @click.stop>View receipt</a>
                                            </div>
                                            <button class="btn-adjust" 
                                                    :class="{ 'btn-add': !appliedAdjustments[adj.id], 'btn-remove': appliedAdjustments[adj.id] }">
                                                <i v-if="!appliedAdjustments[adj.id]" class="fas fa-plus"></i>
                                                <i v-else class="fas fa-minus"></i>
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </span>
                        <!-- <button class="btn-add" @click="applyAdjustment({impact: totalAdjustments < 0 ? 'Deduction' : 'Addition', amount: Math.abs(totalAdjustments), adjustmentType: 'Other Adjustments', reason: ''})">+</button> -->
                    </div>
                    <input type="number" v-model="extraAmountAdjustmentInput" :disabled="isDisabled" placeholder="0"
                        @wheel="$event.target.blur()"
                        :class="{ 'updated-field': hasChanged('extraAmountAdjustmentInput') }" />
                </div>
                <div class="payroll-salary-calculation-form-group">
                    <div class="input-with-reset">
                        <label>Adjustment Note</label>
                        <ResetIconButton @reset="() => resetIfEmpty('extraAmountAdjustmentNote')" />
                    </div>
                    <textarea class="payroll-adjustment-textarea" v-model="extraAmountAdjustmentNoteInput"
                        :disabled="isDisabled" placeholder="Optional note about adjustment"
                        :class="{ 'updated-field': hasChanged('extraAmountAdjustmentNoteInput') }">
                    </textarea>
                </div>
                <div class="payroll-salary-calculation-form-group">
                    <div class="input-with-reset">
                        <label>Bonus (PKR)</label>
                        <ResetIconButton @reset="() => resetIfEmpty('bonusInput')" />
                    </div>
                    <input type="number" v-model="bonusInput" :disabled="isDisabled" placeholder="0" min="0"
                        @wheel="$event.target.blur()" :class="{ 'updated-field': hasChanged('bonusInput') }" />
                </div>
                <div class="payroll-salary-calculation-form-group" style="display: flex; gap: 10px;">
                    <div style="width: 45%;">
                        <div class="input-with-reset">
                            <label>Tax Deduction (PKR) <span class="salary-calculation-minus">-</span></label>
                            <span class="required-hours-tooltip-wrapper" @mouseover="showTaxInfo" @mouseleave="hideTaxInfo">
                                <i class="fa fa-info-circle" style="color: yellowgreen;"></i>
                                <div v-if="isTaxInfoVisible" class="required-hours-tooltip-box" style="margin-left: -150px;">
                                    <b>Income Tax Slabs:</b>
                                    <ul>
                                        <li v-for="(slab, index) in formattedTaxSlabs" :key="index">{{ slab }}</li>
                                    </ul>
                                </div>
                            </span>
                        </div>
                        <input type="number" :value="taxDeduction" disabled placeholder="0" class="payroll-disabled-field" />
                    </div>
                    <div style="width: 45%;">
                        <div class="input-with-reset">
                            <label>Transaction Fees (PKR)</label>
                            <ResetIconButton @reset="() => resetIfEmpty('transactionFeesInput')" />
                        </div>
                        <input type="number" v-model="transactionFeesInput" :disabled="isDisabled" placeholder="0" min="0"
                            @wheel="$event.target.blur()"
                            :class="{ 'updated-field': hasChanged('transactionFeesInput') }" />
                    </div>
                </div>

                <div class="payroll-salary-calculation-summary">
                    <div class="summary-row final">
                        <div class="label">Final Amount:</div>
                        <div class="value">PKR {{ finalAmountUpdate() }}</div>
                    </div>
                </div>

                <div class="payroll-salary-calculation-actions" v-if="!isDisabled">
                    <div class="right-buttons">
                        <button v-if="!isProcessed && !isPaymentProcessed && !isDraftProcessed && this.employee.status !== 'Draft'"
                            class="payroll-salary-calculation-btn btn-outline" @click="saveDraft">
                            <span class="save-icon">💾</span> Save Draft
                        </button>
                        <button v-if="!isPaymentProcessed && isDraftProcessed"
                            class="payroll-salary-calculation-btn btn-secondary" @click="updateDraft">
                            Update Draft
                        </button>
                        <button v-if="!isPaymentProcessed && isDraftProcessed"
                            class="payroll-salary-calculation-btn btn-danger" @click="deleteDraft">
                            Delete Draft
                        </button>
                        <button :disabled="isProcessing || isPaymentProcessed" :class="[
                            'payroll-salary-calculation-btn',
                            isPaymentProcessed ? 'payroll-btn-success' : isProcessing ? 'btn-success' : 'btn-success',
                            { 'button-loading': isProcessing }
                        ]" @click="processPayment">
                            <span v-if="isProcessing">
                                <i class="fa fa-spinner fa-spin" style="margin-right: 10px;"></i> Generating...
                            </span>
                            <span v-else-if="isPaymentProcessed">
                                <i class="fa fa-check-circle" style="margin-right: 10px;"></i> Payslip Generated
                            </span>
                            <span v-else>
                                <i class="fa fa-credit-card" style="margin-right: 10px;"></i> Payslip Generate
                            </span>
                        </button>

                        <button @click="this.handleDownloadClick" class="payslip-download" v-if="isPaymentProcessed">
                            <i class="fa fa-download" style="color: #3D5953; font-size: 24px;"></i>
                        </button>

                    </div>
                </div>

                <div v-if="!this.isAdmin && this.employee.status === 'Processed'" class="payslip-download-acton">
                    <button :class="[
                        'payroll-salary-calculation-btn', 'payroll-btn-success']" style="margin-top: 20px;">
                        <span>
                            <i class="fa fa-check-circle" style="margin-right: 10px;"></i> Payment Processed
                        </span>
                    </button>
                    <button @click="this.handleDownloadClick" class="payslip-download" v-if="isPaymentProcessed">
                        <i class="fa fa-download" style="color: #3D5953; font-size: 20px;"></i>
                    </button>
                </div>
            </div>
        </div>
        <div style="display: none;">
            <PaySlip :employee="this.employee" :isPaymentProcessed="isPaymentProcessed" />
        </div>
    </div>
</template>

<script>
import {
    monthMap,
    newLateThresholds
} from '../../../../assets/config/constants';
import { calculateTotalHoursAndMinutes, formatAndFilterZeroMins, formatHoursDetails, getAboveHalfDayExtra, getRemainingHours, stripeLeadingZero, sumHoursAndMinutes } from '../../../../assets/config/helpers';
import ResetIconButton from "../../../UIComponents/Buttons/ResetIconButton.vue";
import PaySlip from '../../Payslip/PaySlip.vue';
import firebase from '../../../../assets/config/firebase';

export default {
    name: "SalaryCalculation",
    components: {
        ResetIconButton,
        PaySlip
    },
    props: ["employee", "initialValues", "paymentProcessedLoaded", "draftLoaded", "isActionProcessing"],
    data() {
        const user = this.$store.state.auth.user;
        return {
            isAdmin: user && user.role === "admin",
            perDaySalaryInput: "",
            totalDaysSalaryInput: "",
            lateDeductionInput: "",
            leavesEncashmentAmountInput: "",
            extraAmountAdjustmentInput: "",
            bonusInput: "",
            transactionFeesInput: "",
            lateSalaryDeductionInput: 0,
            lateDeductionDays: 0,
            lateArrivalsInput: "",
            finalAmount: 0,
            annualLeavesEncashmentDays: 0,
            annualLeavesEncashmentAmount: 0,
            isProcessed: false,
            perDaySalaryManuallySet: false,
            leaveDeductionDays: 0,
            manualSalaryDeduction: null,
            manualLeaveEncashmentUpdate: false,
            leavesDaysReducedByLate: 0,
            extraAmountAdjustmentNoteInput: "",
            isleaveInfoVisible: false,
            isAdjustmentInfoVisible: false,
            adjustmentShowHoverTooltip: false,
            isTaxInfoVisible: false,
            isAdjustmentDetailsVisible: false,
            taxDeductionInput: 0,
            taxSlabs: {},
            adjustments: [],
            appliedAdjustments: {}
        };
    },
    created: async function() {
        try {
            this.taxSlabs = await firebase.fetchTaxSlabs();
            this.adjustments = await firebase.getAdjustments(this.employee.year, this.employee.month, this.employee.employeeId);
            // Initialize appliedAdjustments based on extraAmountAdjustmentNoteInput
            const note = this.employee.extraAmountAdjustmentNote || '';
            this.adjustments.forEach(adj => {
                const isNonCustom = adj.amount.includes('x') || adj.amount.includes('day');
                const amountDisplay = Math.round(Math.abs(typeof adj.amount === 'number' ? adj.amount : this.calculateAdjustmentAmount(adj.amount)));
                const notePattern = `Rs. ${amountDisplay}${isNonCustom ? `(${adj.amount})` : ''} (${adj.adjustmentType}) ${adj.reason}`;
                if (note.includes(notePattern)) {
                    this.$set(this.appliedAdjustments, adj.id, true);
                }
            });
            // Check for Low/Extra Hours adjustment
            const lowExtraHoursPattern = `Rs. ${Math.abs(this.calculateExtraAmount())} for Low/Extra Hours Sum:`;
            if (note.includes(lowExtraHoursPattern)) {
                this.$set(this.appliedAdjustments, 'lowExtraHours', true);
            }
        } catch (error) {
        }
    },
    computed: {
        selectedEmployee() {
            return this.$store.state.payroll.selectedEmployeePayroll || {};
        },
        taxDeduction() {
            const availableYears = Object.keys(this.taxSlabs).map(Number).sort((a, b) => b - a);
            const selectedYear = availableYears.includes(Number(this.employee.year)) ? Number(this.employee.year) : availableYears[0] || 2025;
            const slabs = this.taxSlabs[selectedYear] || {};

            const annualSalary = ((this.selectedEmployee.basicSalary || 0) + (this.selectedEmployee.extraAllowance || 0)) * 12;
            const medicalExemption = annualSalary * 0.065;
            const taxableSalary = annualSalary - medicalExemption;

            let annualTax = 0;
            const thresholds = Object.keys(slabs).map(Number).sort((a, b) => a - b);
            for (let i = 0; i < thresholds.length; i++) {
                const threshold = thresholds[i];
                const slab = slabs[threshold];
                const nextThreshold = thresholds[i + 1] || Infinity;
                if (taxableSalary >= threshold && taxableSalary < nextThreshold) {
                    annualTax = slab.fixed + (taxableSalary - threshold) * (slab.percentage / 100);
                    break;
                }
            }

            const monthlyTax = annualTax / 12;
            this.taxDeductionInput = monthlyTax.toFixed(1);
            return stripeLeadingZero(monthlyTax.toFixed(1));
        },
        formattedTaxSlabs() {
            const availableYears = Object.keys(this.taxSlabs).map(Number).sort((a, b) => b - a);
            const selectedYear = availableYears.includes(Number(this.employee.year)) ? Number(this.employee.year) : availableYears[0] || 2025;
            const slabs = this.taxSlabs[selectedYear] || {};
            const thresholds = Object.keys(slabs).map(Number).sort((a, b) => a - b);
            const formatted = [];
            for (let i = 0; i < thresholds.length; i++) {
                const threshold = thresholds[i];
                const slab = slabs[threshold];
                const nextThreshold = thresholds[i + 1] || Infinity;
                const range = nextThreshold === Infinity ? `Above Rs. ${threshold.toLocaleString()}` : `Rs. ${threshold.toLocaleString()} - Rs. ${(nextThreshold - 1).toLocaleString()}`;
                const rate = slab.percentage === 0 ? '0%' : `${slab.percentage}%`;
                const fixed = slab.fixed > 0 ? `Rs. ${slab.fixed.toLocaleString()} + ` : '';
                formatted.push(`${range}: ${fixed}${rate}${slab.percentage > 0 ? ` of amount exceeding Rs. ${threshold.toLocaleString()}` : ''}`);
            }
            return formatted;
        },

        salary() {
            const employee = this.selectedEmployee;
            if (!employee) return {};

            const grossSalary = (employee.basicSalary || 0) + (employee.extraAllowance || 0);
            const calculatedSalary = employee.calculatedSalary || 0;
            const lateDeduction = parseFloat(this.perDayWorkedSalary) * parseFloat(this.calculatedSalaryDeductionDays);

            const workingDays = employee.daysWorked || 0;
            const perDaySalary = employee.perDaySalary || (grossSalary / workingDays).toFixed(2);
            const extraAmountAdjustment = Number(employee.extraAmountAdjustment) || 0;
            const bonus = Number(employee.bonus) || 0;
            const totalSalary = (Number(calculatedSalary) - Number(lateDeduction) + Number(extraAmountAdjustment) + Number(bonus)).toFixed(2)
            const totalDaysSalary = (Number(employee.perDaySalary) * Number(employee.daysWorked) || 0).toFixed(2);
            const leavesEncashmentAmount = Number(employee.perDaySalary * this.leavesCountReducedByLate) || 0;
            const transactionFees = Number(employee.transactionFees) || 0;
            const taxDeduction = Number(this.taxDeduction) || 0;
            const finalAmount = totalDaysSalary - lateDeduction + leavesEncashmentAmount + extraAmountAdjustment + bonus + transactionFees - taxDeduction;
            const annualLeaves = totalDaysSalary - lateDeduction + leavesEncashmentAmount + extraAmountAdjustment + transactionFees;
            const annualLeavesEncashmentAmount = (leavesEncashmentAmount + (Number(employee.perDaySalary) * Number(employee.annualLeavesEncashmentDays))).toFixed(2)
            this.annualLeavesEncashmentAmount = annualLeavesEncashmentAmount || 0;

            return {
                perDaySalary,
                lateDeduction,
                totalSalary,
                transactionFees,
                taxDeduction,
                finalAmount,
                extraAmountAdjustment,
                bonus,
                leavesEncashmentAmount,
                totalDaysSalary,
                annualLeavesEncashmentAmount,
            };
        },
        formattedTotalSalary() {
            return Number(this.salary.totalSalary).toLocaleString();
        },
        formattedFinalAmount() {
            return Number(this.salary.finalAmount).toLocaleString();
        },
        leavesTakenSalary() {
            const leavesTaken = this.selectedEmployee.obtainedLeaves.split(" / ")[0] || 0;
            return this.salary.perDaySalary * leavesTaken || 0;
        },
        formattedLeavesTakenSalary() {
            const perDaySalary = Number(this.salary.perDaySalary)
            console.log(this.salary.perDaySalary)
            if (perDaySalary) return perDaySalary.toLocaleString() || 0;
            return Number(0).toLocaleString();
        },
        formattedPerDayWorkedSalary() {
            return Number(this.selectedEmployee.perDaySalary).toLocaleString();
        },
        formattedPerHoursalary() {
            return Number((this.selectedEmployee.perDaySalary / this.selectedEmployee.empTotalHours)).toFixed(2);
        },
        perDayWorkedSalary() {
            return Number(this.selectedEmployee.perDaySalary);
        },
        calculatedSalaryDeductionDays() {
            return this.lateDeductionDays;
        },

        leavesCountReducedByLate() {
            const employee = this.selectedEmployee || {};
            const recentUpdatedField = this.employee.recentUpdatedField;
            const manualLeaveDeduction = Number(this.employee.manualLeaveDeductionDays) || 0;
            const systemLeaveDeduction = Number(this.employee.leaveDeductionCount || this.employee.leavesDeductionDays) || 0;
            const manualDeduction = Number(employee.leavesDeductionDays) || 0;

            const obtainedLeavesStr = employee.obtainedLeaves || "0 / 0";
            const initObtainedLeavesStr = this.initialValues.obtainedLeaves || "0 / 0";
            const [obtainedLeaves] = obtainedLeavesStr.split(" / ").map(Number) || [0];
            const [initObtainedLeaves] = initObtainedLeavesStr.split(" / ").map(Number) || [0];

            const lateCount = parseInt(this.lateArrivalsInput) || 0;
            const isUpdatedLateArrivals = employee.lateArrivals != this.initialValues.lateArrivals;
            const updatedLateArrivals = isUpdatedLateArrivals ? employee.lateArrivals : lateCount;

            const isUpdatedLeavesTaken = obtainedLeaves !== initObtainedLeaves;
            const updatedLeavesTaken = isUpdatedLeavesTaken ? obtainedLeaves : initObtainedLeaves;

            if (isUpdatedLeavesTaken && recentUpdatedField == "leavesTaken") {
                return Math.max(updatedLeavesTaken - systemLeaveDeduction, 0);
            }

            let salaryDeduction = 0;
            let leaveDeduction = 0;

            if (!manualLeaveDeduction || updatedLateArrivals) {
                for (const threshold of newLateThresholds) {
                    if (updatedLateArrivals >= threshold.min) {
                        salaryDeduction = threshold.salaryDeduct;
                        leaveDeduction = threshold.leaveDeduct;
                    }
                }
            }

            const leavesTaken = Number(employee.leavesTaken) || 0;
            let adjustedLeaves = leavesTaken;

            // ✅ Issue 1 FIX: Late deductions don't affect encashment
            if (recentUpdatedField == "lateArrivals") {
                adjustedLeaves = Math.max(leavesTaken - leaveDeduction, 0);
                this.leavesEncashmentDays = leavesTaken;  // Full leaves for encashment
                this.leavesDaysReducedByLate = leavesTaken;  // Full leaves for salary calc
                this.salaryDeductionDays = salaryDeduction;
                return leavesTaken;  // Return FULL leaves for encashment
            }

            if (isUpdatedLateArrivals && !manualLeaveDeduction) {
                if (systemLeaveDeduction === 0 && obtainedLeaves === 0) {
                    return 0;
                } else {
                    return leavesTaken;  // Full leaves for encashment
                }
            }

            // ✅ Apply manual or system deduction
            let deductionToApply = this.employee.manualLeaveDeductionDays !== null && this.employee.manualLeaveDeductionDays !== undefined
                ? manualLeaveDeduction
                : leaveDeduction;

            deductionToApply = Math.min(deductionToApply, leavesTaken);

            if (leavesTaken === deductionToApply) {
                adjustedLeaves = 0;
            } else if (deductionToApply > 0) {
                adjustedLeaves = Math.max(leavesTaken - deductionToApply, 0);
            } else {
                const isLeaveDeduction = systemLeaveDeduction !== leavesTaken && leavesTaken > systemLeaveDeduction;
                const initialValue = Math.max(leavesTaken - this.employee.leavesDeductionDays, 0);
                adjustedLeaves = isLeaveDeduction ? (initialValue || leavesTaken) : (initialValue || 0);
            }

            // ✅ Apply encashment if triggered
            if (this.manualLeaveEncashmentUpdate && employee.leavesDeductionDays) {
                const encashmentDeduction = employee.leavesDeductionDays >= 1 ? employee.leavesDeductionDays : 0;
                adjustedLeaves = Math.max(adjustedLeaves - encashmentDeduction, 0);
            }

            // ✅ Final assignments - ENCASHMENT uses FULL leaves
            this.leavesEncashmentDays = leavesTaken;
            this.leavesDaysReducedByLate = leavesTaken;
            this.salaryDeductionDays = salaryDeduction;
            this.leavesEncashmentDetails
            return leavesTaken;  // FIXED: Full leaves for encashment
        },

        calculateAnnualLeavesEncashmentDays() {
            const emp = this.selectedEmployee
            return Number(emp.annualLeavesEncashmentDays || emp.leavesQuota && emp.leavesQuota.leavesEncashmentDays) || 0;
        },
        isDisabled() {
            if (!this.isAdmin) return true;
        },
        isPaymentProcessed() {
            if (this.selectedEmployee.status === "Processed" ) return true;
        },
        isDraftProcessed() {
            if (this.selectedEmployee.status === "Draft") return true;
        },
        totalDaysSalaryInputComputed() {
            this.manualSalaryDeduction = null;
            const perDay = parseFloat(this.selectedEmployee.perDaySalary) || 0;
            const days = parseFloat(this.selectedEmployee.daysWorked) || 0;
            this.totalDaysSalaryInput = (perDay * days).toFixed(2);
            return (perDay * days).toFixed(2);
        },
        lateSalaryDeductionUpdate: {
            get() {
                if (this.manualSalaryDeduction !== null) {
                    return this.manualSalaryDeduction;
                }
                const perHourSalary = this.perDayWorkedSalary / this.selectedEmployee.empTotalHours;
                const deduction = (perHourSalary * 4 * this.lateDeductionDays).toFixed(2);
                
                this.lateSalaryDeductionInput = deduction;
                return stripeLeadingZero(deduction);
            },
            set(value) {
                this.manualSalaryDeduction = value;
                this.lateSalaryDeductionInput = value;

                let updatedLateDeduction = this.selectedEmployee.lateDeduction.split(" - ");
                updatedLateDeduction[0] = value || 0;
                this.selectedEmployee.lateDeduction = updatedLateDeduction.join(" - ");

                this.finalAmountUpdate();
            }
        },
        leavesEncashmentAmountUpdate: {
            get() {
                // Otherwise calculate automatically
                const days = this.leavesCountReducedByLate + this.calculateAnnualLeavesEncashmentDays;
                console.log("🚀 ~ get ~ this.leavesCountReducedByLate:", this.leavesCountReducedByLate)
                const rate = this.perDayWorkedSalary;
                const calculatedValue = (days * rate).toFixed(2);
                this.leavesEncashmentAmountInput = calculatedValue;
                return stripeLeadingZero(calculatedValue);
            },
            set(value) {
                this.manualLeaveEncashmentUpdate = true;
                this.leavesEncashmentAmountInput = value;
                this.finalAmountUpdate();
                this.syncToEmployee();
            }
        },
        emptyLeaveBalance() {
            const leaveBalance = Number(this.selectedEmployee.leaveBalance) || 0;
            return leaveBalance > 0 ? false : true;
        },
        reactiveLeaveDays() {
            return this.employee.leavesDeductionDays || 0;
        },
        formattedTotalSpentHours() {
            const emp = this.selectedEmployee;
            const totalHours = Number(emp.totalNormalHours) + Number(emp.totalExtraHours) + Number(emp.totalLowHours) + Number(emp.totalHalfDayHours) || 0;

            // const hours = Math.floor(totalHours);
            // const minutes = Math.round((totalHours - hours) * 60);

            // return `${totalHours.toFixed(2)} hrs`;
            return `${totalHours.toFixed(2)} hrs`;
        },
        formattedRequiredHours() {
            const emp = this.selectedEmployee
            const reqWorkingHours = Number(emp.requiredTotalWorkingHours || emp.reqWorkingHours) || 0;
            this.employee.requiredTotalWorkingHours = reqWorkingHours;
            this.syncToEmployee();
            return reqWorkingHours.toLocaleString();
        },
        formattedDifference() {
            const emp = this.selectedEmployee;

            const totalNormalHours = Number(emp.totalNormalHours) || 0;
            const totalExtraHours = Number(emp.totalExtraHours) || 0;
            const totalLowHours = Number(emp.totalLowHours) || 0;
            const totalHalfDayHours = Number(emp.totalHalfDayHours) || 0;
            const requiredHours = Number(emp.requiredTotalWorkingHours || emp.reqWorkingHours) || 0;
            const perDayHours = Number(emp.perDayProductiveHours || emp.productiveHours) || 1;

            const spentHours = totalNormalHours + totalExtraHours + totalLowHours + totalHalfDayHours;
            const difference = spentHours - requiredHours;

            const sign = difference >= 0 ? "+" : "-";
            const absDifference = Math.abs(difference);

            const differenceInHours = Math.floor(absDifference);
            const differenceInMinutes = Math.round((absDifference - differenceInHours) * 60);

            const totalDecimalHours = differenceInHours + (differenceInMinutes / 60);
            const equivalentDays = totalDecimalHours / perDayHours;

            return {
                hours: `${sign}${differenceInHours} hrs ${differenceInMinutes} mins`,
                days: `${sign}${equivalentDays.toFixed(2)} Days`
            };
        },
        differenceStyle() {
            const spentHours = Number(this.selectedEmployee.totalNormalHours) + Number(this.selectedEmployee.totalExtraHours) || 0;
            const requiredHours = Number(this.selectedEmployee.reqWorkingHours) || 0;
            const diff = spentHours - requiredHours;

            return diff < 0 ? { color: 'red' } : { color: 'green' };
        },
        isProcessing() {
            return this.isActionProcessing;
        },
        leavesEncashmentDetails() {
            const leaveTaken = Number(this.employee.leavesTaken) || 0;
            const leavesDeductionCount = Number(this.employee.leavesDeductionCount || this.employee.leavesDeductionDays) || 0;
            const leavesEncashmentDays = Math.max(leaveTaken - leavesDeductionCount, 0);

            const details = [
                `Leaves Taken: ${leaveTaken}`,
                `Leave Deductions (due to late arrivals): ${leavesDeductionCount}`,
                `Total Leave Deductions: ${leaveTaken - leavesDeductionCount}`,
                `Encashable Leaves: ${leavesEncashmentDays}`
            ];

            return {
                leavesEncashmentDays,
                details
            };
        },
        formattedLeavePolicy() {
            return newLateThresholds
                .sort((a, b) => a.min - b.min)
                .map(threshold => {
                    const parts = [];
                    if (threshold.salaryDeduct > 0) {
                        parts.push(`${threshold.salaryDeduct * 4}x per-hour salary deducted`);
                    }
                    if (threshold.leaveDeduct > 0) {
                        parts.push(`${threshold.leaveDeduct} leave${threshold.leaveDeduct > 1 ? 's' : ''} deducted`);
                    }
                    return `${threshold.min}+ late arrivals: ${parts.join(', ')}`;
                });
        },
        getLeavesAllowed() {
            return Number(this.employee.leavesAllowed) || 0;
        },
        getRequiredHoursInfo() {
            const emp = this.employee;
            const monthNum = String(monthMap[emp.month]).padStart(2, '0');
            const year = emp.year;
            const format = this.formatToHoursMinutes;

            const totalExtraHours = calculateTotalHoursAndMinutes(emp.totalExtraHoursDays);
            const requiredHoursTotal = calculateTotalHoursAndMinutes(emp.requiredTotalWorkingDays);
            const requiredHours = formatHoursDetails(emp.requiredTotalWorkingDays, format, monthNum, year);

            const remainingNormalRaw = getRemainingHours(emp.normalHoursDays, emp.empTotalHours, true);
            const remainingNormal = formatAndFilterZeroMins(remainingNormalRaw, format, monthNum, year);
            const remainingNormalTotal = calculateTotalHoursAndMinutes(remainingNormalRaw);


            const spentLowHours = formatAndFilterZeroMins(emp.lowHoursDays, format, monthNum, year);
            const spentLowHoursTotal = calculateTotalHoursAndMinutes(emp.lowHoursDays);

            const normalHoursRaw = getRemainingHours(emp.normalHoursDays, emp.empTotalHours, true);
            const normalHours = formatAndFilterZeroMins(normalHoursRaw, format, monthNum, year);
            const normalHoursTotal = calculateTotalHoursAndMinutes(normalHoursRaw);

            const allNormalHours = formatHoursDetails(emp.normalHoursDays, format, monthNum, year);
            const allNormalHoursTotal = calculateTotalHoursAndMinutes(emp.normalHoursDays);

            const remainingHalfDaysDetails = formatHoursDetails(emp.remainingHalfDays, format, monthNum, year);
            const remainingHalfDaysTotal = calculateTotalHoursAndMinutes(emp.remainingHalfDays);
            
            
            const halfDayHours = (Number(emp.empTotalHours) / 2) + 0.5;
            const extraTimeAboveHalfDay = getAboveHalfDayExtra(emp.halfDays, halfDayHours);
            const extraTimeAboveHalfDayTotal = calculateTotalHoursAndMinutes(extraTimeAboveHalfDay);
            const extraTimeAboveHalfDayDetails = formatHoursDetails(extraTimeAboveHalfDay, format, monthNum, year);
            const extraTimeAboveHalfDayHours = formatAndFilterZeroMins(extraTimeAboveHalfDay, format, monthNum, year);

            const cumulativeOvertimeHours = sumHoursAndMinutes(totalExtraHours, extraTimeAboveHalfDayTotal);

            const spentHalfDaysDetails = formatHoursDetails(emp.halfDays, format, monthNum, year);
            const spentHalfDaysTotal = calculateTotalHoursAndMinutes(emp.halfDays);

            return {
                requiredHoursDetails: requiredHours,
                remainingHalfDaysDetails,
                spentHalfDaysDetails,
                totalExtraHoursDays: formatHoursDetails(emp.totalExtraHoursDays, format, monthNum, year),
                remainingNormalHours: remainingNormal,
                spentLowHours,
                normalHoursDetails: normalHours,
                allNormalHours: allNormalHours,
                cumulativeOvertimeHours: cumulativeOvertimeHours,
                extraHalfDaysHours: extraTimeAboveHalfDayDetails,
                totals: {
                    totalExtraHours,
                    remainingNormalTotal,
                    spentLowHoursTotal,
                    normalHoursTotal,
                    requiredHoursTotal,
                    allNormalHoursTotal,
                    remainingHalfDaysTotal,
                    spentHalfDaysTotal,
                    cumulativeOvertimeHours,
                    extraTimeAboveHalfDayTotal
                }
            };
        },
        tooltipSections() {
            const info = this.getRequiredHoursInfo;
            return [
                
                { key: 'totalExtraHoursDays', title: 'Spent Extra Hours Details:', text: 'Extra Hours', items: info.totalExtraHoursDays },
                { key: 'extraHalfDaysHours', title: 'Extra Half Days Hours Details:', text: 'Extra Half Days Hours', items: info.extraHalfDaysHours },
                { key: 'spentLowHours', title: 'Unpaid Low Hours Details:', text: 'Unpaid Low Hours', items: info.spentLowHours },
                { key: 'remainingNormalHours', title: 'Paid Low Hours Details:', text: 'Paid Low Hours', items: info.remainingNormalHours },
            ];
        },

        totalsMap() {
            const { totals } = this.getRequiredHoursInfo;
            return {
                spentLowHours: totals.spentLowHoursTotal,
                normalHours: totals.normalHoursTotal,
                remainingNormalHours: totals.remainingNormalTotal,
                totalExtraHoursDays: totals.totalExtraHours,
                requiredHours: totals.requiredHoursTotal,
                allNormalHours: totals.allNormalHoursTotal,
                remainingHalfDays: totals.remainingHalfDaysTotal,
                spentHalfDays: totals.spentHalfDaysTotal,
                cumulativeOvertimeHours: totals.cumulativeOvertimeHours,
                extraHalfDaysHours: totals.extraTimeAboveHalfDayTotal
            };
        },

        totalSummary() {
            const getTotalMins = (obj = {}) => (obj.hrs || 0) * 60 + (obj.mins || 0);

            const {
                allNormalHours,
                remainingNormalHours,
                spentLowHours,
                spentHalfDays,
                totalExtraHoursDays,
                requiredHours,
                extraTimeAboveHalfDay,
                cumulativeOvertimeHours,
                extraHalfDaysHours
            } = this.totalsMap;

            const perDayHours = Number(this.selectedEmployee.perDayProductiveHours || this.selectedEmployee.productiveHours) || 1;

            const normalTotalMins = getTotalMins(allNormalHours);
            const lowTotalMins = getTotalMins(spentLowHours);
            const halfDaysMins = getTotalMins(spentHalfDays);
            const extraHoursMins = getTotalMins(totalExtraHoursDays) + getTotalMins(extraTimeAboveHalfDay);
            const cumulativeOvertimeMins = getTotalMins(cumulativeOvertimeHours);
            const extraTimeAboveHalfDayMins = getTotalMins(extraHalfDaysHours);
            const requiredWorkingMins = getTotalMins(requiredHours);
            const remainingNormalMins = getTotalMins(remainingNormalHours);

            const summaryTotalMins = lowTotalMins + cumulativeOvertimeMins - remainingNormalMins;
            const grandTotalMins = summaryTotalMins;

            const diffMins = Math.abs(summaryTotalMins);
            const nonSignDiffMins = Math.abs(diffMins)

            const format = (mins) => {
                const sign = mins < 0 ? '-' : '';
                const absMins = Math.abs(mins);
                const hrs = Math.floor(absMins / 60);
                const rem = absMins % 60;
                return `${sign}${hrs} hrs ${rem} mins`;
            };

            const sign = diffMins >= 0 ? '' : '-';
            const absDiffMins = Math.abs(diffMins);
            const diffHrs = Math.floor(absDiffMins / 60);
            const diffRemMins = absDiffMins % 60;
            const totalDecimalHours = diffHrs + (diffRemMins / 60);
            const equivalentDays = totalDecimalHours / perDayHours;

            const nonSignAbsDiffMins = Math.abs(nonSignDiffMins);
            const nonSignDiffHrs = Math.floor(nonSignAbsDiffMins / 60);
            const nonSignDiffRemMins = nonSignAbsDiffMins % 60;
            const nonSignTotalDecimalHours = nonSignDiffHrs + (nonSignDiffRemMins / 60);
            const nonSignEquivalentDays = nonSignTotalDecimalHours / perDayHours;


            return {
                normalAndRemainingNormal: format(normalTotalMins),
                lowAndRemainingLow: format(lowTotalMins),
                remainingNormalHours: format(remainingNormalMins),
                spentHalfDaysOnly: format(halfDaysMins),
                extraHours: format(extraHoursMins),
                cumulativeOvertimeHours: format(cumulativeOvertimeMins),
                extraHalfDaysHours: format(extraTimeAboveHalfDayMins),
                summaryTotal: format(summaryTotalMins),
                grandTotal: format(grandTotalMins),
                nonSignGrandTotal: format(Math.abs(grandTotalMins)),
                requiredWorkingHours: format(requiredWorkingMins),
                difference: {
                    text: `${sign}${diffHrs} hrs ${diffRemMins} mins`,
                    nonSignText: `${nonSignDiffHrs} hrs ${nonSignDiffRemMins} mins`,
                    days: `${sign}${equivalentDays.toFixed(2)} Days`,
                    nonSignDays: `${sign}${nonSignEquivalentDays.toFixed(2)} Days`,
                    isPositive: diffMins >= 0,
                    color: grandTotalMins >= 0 ? 'green' : 'red'
                }
            };
        },
        calcExtraAmountAdjustment() {
            return this.calculateExtraAmount;
        },
        calculateExtraAmount() {
            const hourlyRate = Number(this.employee.perDaySalary) / Number(this.empDayHours().empTotalHours);
            const extraHoursText = this.totalSummary.difference.nonSignText || '0 hrs 0 mins';

            const isNegative = this.totalSummary.grandTotal.trim().startsWith('-');
            const match = extraHoursText.match(/-?(\d+)\s*hrs?\s*(\d+)?\s*mins?/i);

            const hours = match ? Number(match[1]) : 0;
            const mins = match && match[2] ? Number(match[2]) : 0;

            let totalHours = hours + mins / 60;
            if (isNegative) totalHours = -totalHours;
            const finalvalue=  Math.round(totalHours * hourlyRate);
            return finalvalue
        },
        totalAdjustments() {
            const perDaySalary = Number(this.selectedEmployee.perDaySalary) || 0;
            return this.adjustments.reduce((sum, adj) => {
                let adjustmentValue = typeof adj.amount === 'number' ? adj.amount : this.calculateAdjustmentAmount(adj.amount);
                // Apply impact logic: add for Addition, subtract for Deduction
                if (adj.impact === "Addition") {
                    return sum + Math.abs(adjustmentValue);
                } else if (adj.impact === "Deduction") {
                    return sum - Math.abs(adjustmentValue);
                }
                return sum;
            }, 0).toFixed(2);
        },
    },
    watch: {
        employee: {
            immediate: true,
            deep: true,
            handler: function (newVal) {
                const emp = this.employee
                emp.employeeName = newVal.employeeName || ""
                emp.basicSalary = newVal.basicSalary || 0
                emp.extraAllowance = newVal.extraAllowance || 0
                emp.perDaySalary = newVal.perDaySalary || 0
                emp.requiredWorkingDays = newVal.requiredWorkingDays || 0
                this.perDaySalaryManuallySet = false;
                this.updateSalaryData();
                this.finalAmountUpdate();
                this.leavesDaysReducedByLate
                this.leavesDaysReducedByLate = this.leavesCountReducedByLate || 0;
            },
        },
        selectedEmployee: {
            handler(newVal) {
                if (!newVal) return;
                this.updateSalaryData();
                this.finalAmountUpdate()
            },
            deep: true,
            immediate: true
        },
        lateArrivalsInput: {
            handler(newVal) {
                this.calculateDeductions();
            },
            immediate: true
        },
        lateDeductionDays: {
            handler(oldVal, newVal) {
                this.updateSalaryData();
                this.finalAmountUpdate();
            },
            immediate: true
        },
        reactiveLeaveDays(newVal) {
            this.finalAmountUpdate();
        },
        leavesEncashmentAmountInput: {
            handler(newVal) {
                this.finalAmountUpdate();
            },
            immediate: true
        },
        manualLeaveEncashmentUpdate: {
            handler(newVal) {
                this.finalAmountUpdate();
            },
            immediate: true
        },
        taxDeduction: {
            handler(newVal) {
                this.updateSalaryData();
                this.finalAmountUpdate();
            },
            immediate: true
        }
    },
    methods: {
        updateSalaryData() {
            if (!this.selectedEmployee) return;
            const [leavesTaken, leaveBalance] = this.selectedEmployee.obtainedLeaves ? this.selectedEmployee.obtainedLeaves.split(" / ").map(Number) : "0 / 0";
            const perDaySalary = Number(this.selectedEmployee.perDaySalary) || 0;
            const annualLeaves = this.selectedEmployee.annualLeavesEncashmentDays
            const totalLeavesTaken = Number((leavesTaken || 0) + (annualLeaves || 0)) || 0;
            let leaveDeductionByLate = this.leaveDeductionDays >= 1 ? this.leaveDeductionDays : 0

            this.perDaySalaryInput = this.selectedEmployee.perDaySalary || 0;

            if (!this.totalDaysSalaryInput) {
                this.totalDaysSalaryInput =
                    ((parseFloat(this.selectedEmployee && this.selectedEmployee.perDaySalary) || 0) *
                        (parseFloat(this.selectedEmployee && this.selectedEmployee.daysWorked) || 0)).toFixed(2);
            }

            this.lateDeductionInput = this.selectedEmployee.lateDeduction || 0;
            this.extraAmountAdjustmentInput = this.selectedEmployee.extraAmountAdjustment || "";
            this.extraAmountAdjustmentNoteInput = this.selectedEmployee.extraAmountAdjustmentNote || "";
            this.bonusInput = this.selectedEmployee.bonus || "";
            this.transactionFeesInput = this.selectedEmployee.transactionFees || "";
            this.taxDeductionInput = this.selectedEmployee.taxDeduction || 0;
            const savedLate = this.employee.lateDeductionDays;
            this.lateDeductionDays = Number.isFinite(Number(savedLate)) ? Number(savedLate) : (this.selectedEmployee.lateDeductionDays || 0);
            if (!this.leavesEncashmentAmountInput) {
                this.leavesEncashmentAmountInput = totalLeavesTaken ?
                    ((parseFloat((perDaySalary * (this.leavesCountReducedByLate || 0)).toFixed(2)) +
                        parseFloat((perDaySalary * (annualLeaves || 0)).toFixed(2))).toFixed(2)) :
                    this.selectedEmployee.leavesEncashmentAmount || 0;
            }

            this.lateArrivalsInput = this.selectedEmployee.lateArrivals || 0;
            this.annualLeavesEncashmentDays = annualLeaves;
            // this.annualLeavesEncashmentAmount = (perDaySalary * (annualLeaves || 0)).toFixed(2) || 0;
        },
        processPayment() {
            this.$emit("process-payment");
        },
        saveDraft() {
            this.$emit("save-draft");
        },
        updateDraft() {
            this.$emit("update-draft");
        },
        deleteDraft() {
            this.$emit("delete-draft");
        },
        calculateDeductions() {
            this.manualSalaryDeduction = null;
            const obtLeaves = this.selectedEmployee.obtainedLeaves || "0 / 0";
            let [obtainedLeaves] = obtLeaves || obtLeaves.split(" / ").map(Number) || [0];
            const isObtainedLeaves = obtainedLeaves > 0;
            let lates = parseInt(this.lateArrivalsInput) || 0;
            let leaveDeductionDays = 0;
            let lateDeductionDays = 0;
            let totalLatesCount = 0;

            for (const threshold of newLateThresholds) {

                if (lates >= threshold.min) {
                    totalLatesCount = threshold.lates;
                    lateDeductionDays = isObtainedLeaves ? threshold.lates - 1 : threshold.lates;
                    leaveDeductionDays = isObtainedLeaves ? 1 : 0;
                    break;
                }
            }

            // Deduct 1 leave if lateCount is at least 1
            if (lates >= 1) {
                obtainedLeaves = Math.max(0, obtainedLeaves - 1);
            }
            const processedLeavesQuota = this.selectedEmployee.leavesQuota
            const {
                carryForwardDays,
                leavesEncashmentDays
            } = processedLeavesQuota || {}

            this.leaveDeductionInput = Number(leaveDeductionDays || 0);
            console.log("🚀 ~ calculateDeductions ~ calculateDeductions lateDeductionDays:", lateDeductionDays)

            const empStatus = (this.employee && this.employee.status || "").toLowerCase();
            const hasSavedLateDeduction = (empStatus === "draft" || empStatus === "processed") && Number.isFinite(Number(this.employee.lateDeductionDays));
            this.lateDeductionDays = hasSavedLateDeduction ? Number(this.employee.lateDeductionDays) : lateDeductionDays;

            this.lateDeductionDays = lateDeductionDays;

            const perDaySalary = this.selectedEmployee.perDaySalary || 0;

            this.totalLatesCount = totalLatesCount
            this.lateSalaryDeductionInput = (lateDeductionDays * perDaySalary).toFixed(2);

            let leavesTaken = this.selectedEmployee.obtainedLeaves ? parseInt(this.selectedEmployee.obtainedLeaves.split(" / ")[0]) : 0;
            let adjustedLeaves = Math.max(0, leavesTaken - leaveDeductionDays);
            this.$set(this.selectedEmployee, "adjustedLeavesTaken", adjustedLeaves);
        },
        finalAmountUpdate() {
            const leavesEncashment = this.manualLeaveEncashmentUpdate
                ? Number(this.leavesEncashmentAmountInput || 0)
                : (this.perDayWorkedSalary * (this.leavesCountReducedByLate + this.calculateAnnualLeavesEncashmentDays)).toFixed(2);

            const calc = Number(this.totalDaysSalaryInput || 0) -
                Number(this.lateSalaryDeductionInput || 0) +
                Number(leavesEncashment || 0) +
                Number(this.extraAmountAdjustmentInput || 0) +
                Number(this.bonusInput || 0) +
                Number(this.transactionFeesInput || 0) -
                Number(this.taxDeduction || 0);

            this.finalAmount = Math.round(calc)
            this.syncToEmployee()
            return Math.round(calc);
        },
        formatSalaryInput(field) {
            if (this[field] === "" || isNaN(parseFloat(this[field]))) {
                this[field] = "0.00";
            } else {
                this[field] = parseFloat(this[field]).toFixed(2);
            }
        },
        syncToEmployee() {
            const updated = Object.assign({}, this.employee, {
                lateDeduction: this.lateSalaryDeductionInput,
                extraAmountAdjustment: this.extraAmountAdjustmentInput,
                extraAmountAdjustmentNote: this.extraAmountAdjustmentNoteInput,
                bonus: this.bonusInput,
                transactionFees: this.transactionFeesInput,
                taxDeduction: this.taxDeduction,
                totalSalary: Number(this.totalDaysSalaryInput),
                finalAmount: this.finalAmount,
                leavesEncashmentDays: this.leavesEncashmentDays,
                annualLeavesEncashmentDays: this.annualLeavesEncashmentDays,
                // leavesEncashmentAmount: this.leavesEncashmentAmountInput,
                leavesEncashmentAmount: this.manualLeaveEncashmentUpdate
                    ? Number(this.leavesEncashmentAmountInput)
                    : (this.perDayWorkedSalary * (this.leavesCountReducedByLate + this.calculateAnnualLeavesEncashmentDays)).toFixed(2)
            });
            this.$emit("update-salary", updated); // emit updated employee data
        },
        handleExternalUpdate() {
            this.lateDeductionDays = Number(this.employee.lateDeductionDays) || 0;
            this.finalAmountUpdate();

        },
        resetIfEmpty(field) {
            // Check if the input field is empty
            if (true) {
                const employeeField = field.replace('Input', '');

                // Reset to initial value if available, otherwise to 0
                this[field] = this.initialValues[employeeField] || 0;

                if (field === 'lateSalaryDeductionUpdate') {
                    this.lateSalaryDeductionUpdate();
                }
                if (field === 'leavesEncashmentAmountInput') {
                    this.leavesEncashmentAmountInput()
                }
                if (field === 'extraAmountAdjustmentInput') {
                    this.extraAmountAdjustmentInput = this.initialValues.extraAmountAdjustment || 0;
                    this.appliedAdjustments = {}; // Reset appliedAdjustments
                }
                if (field === 'extraAmountAdjustmentNote') {
                    this.extraAmountAdjustmentNote = this.initialValues.extraAmountAdjustmentNote || 0;
                }
                if (field === 'bonusInput') {
                    this.bonusInput = this.initialValues.bonus || 0;
                }
                if (field === 'transactionFeesInput') {
                    this.transactionFeesInput = this.initialValues.transactionFees || 0;
                }
                if (field === 'extraAmountAdjustmentNote') {
                    this.extraAmountAdjustmentNoteInput = this.initialValues.extraAmountAdjustmentNote || 0;
                }
                this.syncToEmployee();

                // Update the employee object if needed
                if (this.employee[employeeField] !== this[field]) {
                    this.employee[employeeField] = this[field];
                    this.syncToEmployee();
                }
            }
        },

        handleLeaveEncashment(e) {
            this.manualLeaveEncashmentUpdate = true
            this.leavesEncashmentAmountInput = e.target.value;
            this.finalAmountUpdate();
            this.syncToEmployee();

        },
        hasChanged(field) {
            const employeeField = field.replace('Input', '');
            return this[field] !== (this.initialValues[employeeField] || 0);
        },
        showLeavesInfo() {
            this.isleaveInfoVisible = true;
        },
        hideLeavesInfo() {
            this.isleaveInfoVisible = false;
        },
        showAdjustmentInfo() {
            this.isAdjustmentInfoVisible = true;
        },
        hideAdjustmentInfo() {
            this.isAdjustmentInfoVisible = false;
        },
        showAdjustmentDetails() {
            this.isAdjustmentDetailsVisible = true;
        },
        hideAdjustmentDetails() {
            this.isAdjustmentDetailsVisible = false;
        },
        showTaxInfo() {
            this.isTaxInfoVisible = true;
        },
        hideTaxInfo() {
            this.isTaxInfoVisible = false;
        },
        handleDownloadClick() {
            const payslipId = `${this.employee.employeeId}`;

            localStorage.setItem(`payslipData_${payslipId}`, JSON.stringify({
                employee: this.employee,
                salaryData: {
                    totalDaysSalary: this.totalDaysSalaryInput,
                    lateDeduction: this.lateSalaryDeductionInput,
                    leavesEncashment: this.leavesEncashmentAmountInput,
                    adjustment: this.extraAmountAdjustmentInput,
                    bonus: this.bonusInput,
                    transactionFees: this.transactionFeesInput,
                    taxDeduction: this.taxDeduction,
                    finalAmount: this.finalAmount,
                    leavesEncashmentDays: this.leavesEncashmentDays,
                    annualLeavesEncashmentDays: this.annualLeavesEncashmentDays,
                }
            }));

            const baseUrl = window.location.origin;
            const payslipUrl = `${baseUrl}/#/payroll/payslip/${payslipId}`;
            window.open(payslipUrl, '_blank');
        },
        formatToHoursMinutes(decimal) {
            const d = parseFloat(decimal);
            if (isNaN(d)) return '-';

            const hours = Math.floor(d);
            const minutes = Math.round((d - hours) * 60);

            const hrsText = hours ? `${hours} hr${hours !== 1 ? 's' : ''}` : '0 hrs';
            const minsText = minutes ? `${minutes} min${minutes !== 1 ? 's' : ''}` : '0 mins';

            return [hrsText, minsText].filter(Boolean).join(' ') || '0 min';
        },
        empDayHours() {
            const hours = Number(this.employee.empTotalHours)
            const halfDayHours = (hours / 2) + 0.5;
            return {
                halfDayHours,
                empTotalHours: hours
            };
        },
        applyAdjustment(adjOrAmount, note) {
            console.log("adjorAmount", adjOrAmount +"note", note)
            this.adjustmentShowHoverTooltip = false;
            let adjustmentValue;
            let finalNote;
            if (typeof adjOrAmount === 'object' && adjOrAmount !== null) {
                adjustmentValue = typeof adjOrAmount.amount === 'number' ? adjOrAmount.amount : Number(this.calculateAdjustmentAmount(adjOrAmount.amount));
                const isNonCustom = adjOrAmount.amount.includes('x') || adjOrAmount.amount.includes('day');
                finalNote = `Rs. ${Math.round(Math.abs(adjustmentValue))}${isNonCustom ? ` (${adjOrAmount.amount})` : ''} (${adjOrAmount.adjustmentType}) ${adjOrAmount.reason}`;
                this.$set(this.appliedAdjustments, adjOrAmount.id, true);
            } else {
                const lowExtraHoursKey = 'lowExtraHours';
                const isApplied = !!this.appliedAdjustments[lowExtraHoursKey];
                adjustmentValue = adjOrAmount;
                finalNote = `Rs. ${adjustmentValue} for Low/Extra Hours Sum: ${adjustmentValue < 0 ? '-' : ''} ${note.split(': ')[1]}`;
                const currentAdjustment = Number(this.extraAmountAdjustmentInput) || 0;
                const currentNote = this.extraAmountAdjustmentNoteInput || '';
                if (isApplied) {
                    // Remove the adjustment
                    this.extraAmountAdjustmentInput = (currentAdjustment - adjustmentValue).toFixed(2);
                    this.extraAmountAdjustmentNoteInput = currentNote.replace(finalNote, '').trim();
                    this.$set(this.appliedAdjustments, lowExtraHoursKey, false);
                } else {
                    // Add the adjustment
                    this.extraAmountAdjustmentInput = (currentAdjustment + adjustmentValue).toFixed(2);
                    this.extraAmountAdjustmentNoteInput = currentNote ? `${currentNote}\n${finalNote}` : finalNote;
                    this.$set(this.appliedAdjustments, lowExtraHoursKey, true);
                }
            }
            this.syncToEmployee();
        },
        toggleAdjustment(adj) {
            const adjustmentValue = typeof adj.amount === 'number' ? adj.amount : Number(this.calculateAdjustmentAmount(adj.amount));
            // Apply impact logic: use positive value for Addition, negative for Deduction
            const adjustedValue = adj.impact === "Addition" ? Math.abs(adjustmentValue) : -Math.abs(adjustmentValue);
            const isNonCustom = adj.amount.includes('x') || adj.amount.includes('day');
            const finalNote = `Rs. ${Math.round(Math.abs(adjustmentValue))}${isNonCustom ? ` (${adj.amount})` : ''} (${adj.adjustmentType}) ${adj.reason}`;
            const currentAdjustment = Number(this.extraAmountAdjustmentInput) || 0;
            const currentNote = this.extraAmountAdjustmentNoteInput || '';

            if (!this.appliedAdjustments[adj.id]) {
                this.extraAmountAdjustmentInput = (currentAdjustment + adjustedValue).toFixed(2);
                this.extraAmountAdjustmentNoteInput = currentNote ? `${currentNote}\n${finalNote}` : finalNote;
                this.$set(this.appliedAdjustments, adj.id, true);
            } else {
                this.extraAmountAdjustmentInput = (currentAdjustment - adjustedValue).toFixed(2);
                this.extraAmountAdjustmentNoteInput = currentNote.replace(finalNote, '').trim();
                this.$set(this.appliedAdjustments, adj.id, false);
            }
            this.syncToEmployee();
        },
        calculateAdjustmentAmount(amount) {
            // If amount is a string and does not contain 'x' or 'day', treat as custom value and return as-is
            if (typeof amount === 'string' && !amount.includes('x') && !amount.includes('day')) {
                return Number(amount);
            }
            // Otherwise, calculate for non-custom values (1x, 2x, 1 day, etc.)
            const perDaySalary = Number(this.selectedEmployee.perDaySalary) || 0;
            const hourlyRate = perDaySalary / 9;
            const multiplier = parseFloat(amount) || 1;
            const isDay = amount.includes('day');
            return isDay ? (perDaySalary * multiplier) : (hourlyRate * multiplier);
        },
    },
    mounted() {
        this.finalAmountUpdate();
    }
};
</script>

<style scoped>
.adjustment-card-receipt {
    font-size: 12px;
    font-weight: 600;
    color: #435851;
    text-decoration: underline;
}


</style>


// WEBPACK FOOTER //
// src/components/PayrollManagement/PayrollDetails/SalaryCalculation/index.vue